const STORAGE_KEY = 'session_expired_notification';
const RELOAD_STORAGE_KEY = 'csrf_reload_notification';
const RELOAD_AT_STORAGE_KEY = 'csrf_reload_at';
const RELOAD_LOOP_WINDOW_MS = 10000;

function canUseSessionStorage() {
    try {
        return typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined';
    } catch (e) {
        return false;
    }
}

function resolveLoginUrl(pathname = '') {
    return pathname.startsWith('/admin') ? '/admin/login' : '/login';
}

function persistNotification(key, notification) {
    if (!canUseSessionStorage()) {
        return;
    }

    window.sessionStorage.setItem(key, JSON.stringify(notification));
}

function consumeNotification(key) {
    if (!canUseSessionStorage()) {
        return null;
    }

    const rawValue = window.sessionStorage.getItem(key);

    if (!rawValue) {
        return null;
    }

    window.sessionStorage.removeItem(key);

    try {
        return JSON.parse(rawValue);
    } catch (e) {
        return null;
    }
}

function consumeSessionExpiredNotification() {
    return consumeNotification(STORAGE_KEY);
}

function consumeCsrfReloadNotification() {
    return consumeNotification(RELOAD_STORAGE_KEY);
}

function payloadOf(response) {
    if (response?.responseJSON) {
        return response.responseJSON;
    }

    if (response?.data && typeof response.data === 'object') {
        return response.data;
    }

    try {
        return JSON.parse(response?.responseText);
    } catch (e) {
        return null;
    }
}

function extractMessage(response) {
    const payload = payloadOf(response);

    return payload?.message || payload?.error || null;
}

function extractDescription(response) {
    return payloadOf(response)?.description || null;
}

function isSessionExpiredResponse(response) {
    if (!response) {
        return false;
    }

    if (response.status === 419) {
        return true;
    }

    if (response.status !== 401) {
        return false;
    }

    return extractMessage(response) === 'Unauthenticated.';
}

function redirectToLoginWithSessionExpiredMessage(response, fallbackUrl = resolveLoginUrl(window.location.pathname)) {
    if (!isSessionExpiredResponse(response)) {
        return false;
    }

    persistNotification(STORAGE_KEY, {
        type: 'error',
        message: extractMessage(response) || 'Your session has expired.',
        description: extractDescription(response) || 'Please sign in again to continue.',
    });

    window.location.href = fallbackUrl;

    return true;
}

function reloadedRecently() {
    if (!canUseSessionStorage()) {
        return false;
    }

    const reloadedAt = Number(window.sessionStorage.getItem(RELOAD_AT_STORAGE_KEY));

    return reloadedAt > 0 && Date.now() - reloadedAt < RELOAD_LOOP_WINDOW_MS;
}

function handleSessionFailure(response, fallbackUrl = resolveLoginUrl(window.location.pathname)) {
    if (response?.status === 419 && payloadOf(response)?.authenticated === true && !reloadedRecently()) {
        if (canUseSessionStorage()) {
            window.sessionStorage.setItem(RELOAD_AT_STORAGE_KEY, String(Date.now()));
        }

        persistNotification(RELOAD_STORAGE_KEY, {
            type: 'error',
            message: extractMessage(response) || 'Your session has expired.',
            description: extractDescription(response) || 'Please try again.',
        });
        window.location.reload();

        return true;
    }

    return redirectToLoginWithSessionExpiredMessage(response, fallbackUrl);
}

module.exports = {
    consumeCsrfReloadNotification,
    consumeSessionExpiredNotification,
    handleSessionFailure,
    redirectToLoginWithSessionExpiredMessage,
    resolveLoginUrl,
};
